import { cn } from "@/lib/utils";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { PillTrigger } from "./FilterBar";

/** Una píldora de filtro con una sola opción elegible, como "Monto · Todos ▾". */
export function ChoicePill<T>({
  label,
  options,
  value,
  onChange,
  defaultValue,
}: {
  label: string;
  options: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
  /** El valor que no cuenta como filtro activo. */
  defaultValue: T;
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <PillTrigger
          label={label}
          value={options.find((option) => option.value === value)?.label ?? ""}
          active={value !== defaultValue}
        />
      </PopoverTrigger>
      <PopoverContent align="start" className="w-56">
        <div className="flex flex-col">
          {options.map((option) => (
            <button
              key={option.label}
              type="button"
              onClick={() => onChange(option.value)}
              className={cn(
                "cursor-pointer rounded-sm px-2 py-1.5 text-left text-sm hover:bg-accent",
                value === option.value && "font-semibold text-primary",
              )}
            >
              {option.label}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
